<template>
    <div class="container">
        <div class="header_info">
            <div class="info">
                <div class="address">
                    <img src="../../static/img/address.png"/>
                    <span v-if="languageType == 0">广州市番禺区星力动漫产业园A2-A6</span>
                    <span v-else>A2-A6, Xingli Animation Industrial Park, Panyu District, Guangzhou</span>
                </div>
                <div class="phone" :class="languageType == 1?'en_language':''">
                    <img src="../../static/img/phone.png"/>
                    <span v-if="languageType == 0">+86-20-23885033</span>
                    <span v-else>0085256031419</span>
                </div>
                <div class="language" :class="languageType == 1?'en_language':''" @click="showLanguage = !showLanguage">
                    <div v-if="languageType == 0">
                        <span>简</span>
                        <span>体中文</span>
                    </div>
                    <div v-else>
                         <span>E</span>
                        <span>nglish</span>
                    </div>
                    <ul :class="showLanguage?'active':''">
                        <li @click="selectLanguage(1)">简体中文</li>
                        <li @click="selectLanguage(2)">English</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="header_menu">
            <div class="menu">
                <div class="logo" @click="backHome"><img src="../../static/img/logo.png"/></div>
                <div class="menu_list">
                    <ul>
                        <li style="margin-left:-120px"><div class="after"> </div></li>
                        <li v-for="(item,index) in menuList" :key="index" :class="currenIndex == index?'show_active':''" 
                        @mouseenter="item_enter(index)" @mouseleave="item_leave()" @click="checkIndex(index,item.path)">
                            <div class="before"></div>
                            <div class="text">
                                <p><span style="margin-left:-10px;">{{ item.title }}</span></p>
                                <p><span style="margin-left:0px;">{{ item.otherName}}</span></p>
                            </div>
                            <div class="after"> </div>                            
                        </li>
                        <li>
                            <div class="before"></div>
                        </li>
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="search">
                    <input placeholder="产品名称" v-model="searchKey" @keyup.enter="keyupEnter()" />
                    <div class="search_ico"></div>
                </div>
                <div class="foreign">
                    <a href="https://www.linkedin.com/company/guangzhou-arccer-amusement-technology-co-ltd/"><img src="../../static/img/Linkedin.png" alt=""></a>
                    <a href="https://www.facebook.com/profile.php?id=100008418046181&mibextid=LQQJ4d"><img src="../../static/img/Facebook.png" alt=""></a>
                    <a href="https://instagram.com/arccer_julia?igshid=YmMyMTA2M2Y="><img src="../../static/img/Insgram.png" alt=""></a>
                    <a href="https://youtube.com/@arcceramusementinchina4440"><img src="../../static/img/Youtube.png" alt=""></a>
                </div>
            </div>
            
        </div>
        <div>
            <router-view @changeIndex="changeIndex" ref="change" :languageType="languageType"></router-view>
        </div>
        <div class="footer">
            <div class="footer_top">
                <div class="nav">
                    <ul>
                        <li>
                            <span v-if="languageType == 0">友情链接</span>
                            <span v-else>Links</span>
                        </li>
                        <li>
                            <span v-if="languageType == 0">联系我们</span>
                            <span v-else>Contact us</span>
                        </li>
                        <li>
                            <span v-if="languageType == 0">互动平台</span>
                            <span v-else>interactive platform</span>
                        </li>
                        <div class="clear"></div>
                    </ul>
                </div>
                <div class="link">
                    <div class="link_url">
                        <div class="link_tap">
                            <ul>
                                <li v-for="(item,index) in linkList" :key="index">
                                    <a :href="item.url" target="_blank" v-if="languageType == 0">{{ item.name}}</a>
                                    <a :href="item.url" target="_blank" v-else>{{ item.enName}}</a>
                                </li>
                            </ul>
                        </div>
                        <div class="link_conact">
                            <ul>
                                <li>
                                    <img src="../../static/img/phone_small.png"/>
                                    <span v-if="languageType == 0">电话：+86-20-23885033</span>
                                    <!-- <span v-else>Phone：+86-20-23885033</span> -->
                                    <span v-else>Phone：0085256031419</span>
                                </li>
                                <li>
                                    <img src="../../static/img/address_small.png"/>
                                    <span v-if="languageType == 0">广州市番禺区星力动漫产业园A2-A6</span>
                                    <span v-else>A2-A6, Xingli Animation Industrial Park, Panyu District, Guangzhou</span>
                                </li>
                                <li>
                                    <img src="../../static/img/emall_small.png"/>
                                    <!-- <span >Email：contact@arccer.com</span> -->
                                    <span  v-if="languageType == 0">Email：contact@arccer.com</span>
                                    <span v-else>Email：admin@arccer.com</span>
                                </li>
                                <li v-if="languageType != 0">
                                    <img src="../../static/img/whatsapp.png"/>
                                    <span>WhatsApp：00852-56031419</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="link_ewm">
                        <p v-if="languageType == 0">扫码关注微信公众号</p>
                        <p v-else>Scan the code and follow WeChat public account</p>
                        <div class="server">
                            <img src="../../static/img/shouhou.jpg"/>
                            <p v-if="languageType == 0">售后保修与技术支持</p>
                             <p v-else>Technical Support</p>
                        </div>
                        <div class="information">
                            <p></p>
                            <img src="../../static/img/zixun.jpg"/>
                            <p v-if="languageType == 0">胜骅科技资讯</p>
                            <p v-else>Technology Information</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer_bottom">
                Copyright ©2016-2022 ARCCER TECHNOLOGY All Rights Reserved.<span></span> <a href="https://beian.miit.gov.cn/" style="color:#fff">粤ICP备16051311号-2</a>
            </div>
        </div>
        <div class="back_top" :class="!isScroll?'':'show'" @click="backTop">
            <i class="el-icon-top"></i>
        </div>
        <div class="contact_fixed">
            <div class="icon">
                <i class="el-icon-phone"></i>
            </div>
            <!-- <span v-if="languageType == 0">联系我们</span> -->
            <!-- <span v-else>Contact Us</span> -->
            <div class="contact_slide">
                <ul>
                    <li>
                        <img src="../../static/img/phone_small.png"/>
                        <span v-if="languageType == 0">电话：+86-20-23885033</span>
                        <!-- <span v-else>Phone：+86-20-23885033</span> -->
                        <span v-else>Phone：0085256031419</span>
                    </li>
                    <li>
                        <img src="../../static/img/emall_small.png"/>
                        <span  v-if="languageType == 0">Email：contact@arccer.com</span>
                         <span v-else>Email：admin@arccer.com</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            searchKey:'',
            currenIndex:0,
            showLanguage:false,
            languageType:0,
            isScroll:false,
            menuList:[
                {
                    title:'首页',
                    otherName:'Home',
                    path:'home',
                },
                {
                    title:'关于胜骅',
                    otherName:'About us',
                    path:'introduce'
                },
                {
                    title:'新品推荐',
                    otherName:'New product',
                    path:'newproduct'
                },
                {
                    title:'联系我们',
                    otherName:'Contact us',
                    path:'contact'
                },
                {
                    title:'下载中心',
                    otherName:'Download Center',
                    path:'download'
                },
                {
                    title:'产品展示',
                    otherName:'Product Display',
                    path:'productlist'
                }
            ],
            linkList:[]

        }
    },
    created ()  {
        let language = (navigator.browserLanguage || navigator.language).toLowerCase();
        if(language.indexOf('zh')>-1){
           this.languageType = 0
        }else if(language.indexOf('en')>-1){
            this.languageType = 1
        }else{
            
        }
        this.getLinkList()
        if (this.languageType == 0) {
            this.languageType = sessionStorage.getItem('languageType') == null?0:sessionStorage.getItem('languageType')
        }
        
        const path = this.$route.name
        this.menuList.forEach( (item,index) => {
            if(path == item.path){
                this.currenIndex = index
            }
        })
    },
    mounted () {
        window.addEventListener("scroll", this.handleScroll); //监听滚动事件
    },
    methods:{
        keyupEnter () {
            if (this.$route.name == 'search'){
                this.$refs.change.getSearchList(this.searchKey);
                return
            } 
            
            this.$router.push({ name:'search',query:{key:JSON.stringify(this.searchKey)}},)
        },
         handleScroll() {
            const top = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; 
            if (top > 750) {
               this.isScroll  = true
            }else {
                this.isScroll  = false 
            }
        },
        getLinkList () {
            this.$http({
                url: this.$http.adornUrl('/web/url/list'),
                method: 'post',
                data: {
                    'page':'1',
                    'limit':'999'
                }
                }).then(({data}) => {
                if (data && data.code === 0) {
                    this.linkList = data.page.list.slice(0,8)
                } else {
                    this.linkList = []
                }
            })
        },
        changeIndex (val) {
            this.currenIndex = val
        },
        checkIndex (index,path) {
            this.currenIndex = index
            const url = (this.$route.path).slice(1)
            if (path == url || (url == 'about/introduce' && path == 'introduce') || (url == 'product/productlist' && path == 'productlist')) return
            this.$router.push({ name:path })
        },
        item_enter (index) {
            // this.currenIndex = index
        },
        item_leave () {
            // this.currenIndex = 100
        },
        //  切换中英文
        changeLanguage () {

        },
        showLanguageList () {

        },
        selectLanguage (val) {
            if (val == 1) {
                this.languageType = 0
                sessionStorage.setItem('languageType',0)
            }else {
                this.languageType = 1
                sessionStorage.setItem('languageType',1)
            }
        },
        backHome () {
            if(this.$route.path != '/home'){
                this.currenIndex = 0
                this.$router.push({ name:'home' })
            }
        },
        backTop () {
            document.documentElement.scrollTop=0
        }
    }
}
</script>

<style lang="less" scoped>
    .container {
        min-width: 1903px;
        position: relative;
        overflow-x: hidden;
        .header_info {
            height: 50px;
            .info {
                margin-left:990px;
                text-align: left;
                // overflow: hidden;
            }
            .address {
                height: 40px;
                padding: 5px 0 5px 0;
                display: inline-block;
                img {
                    width: 40px;
                    height: 40px;
                    vertical-align: middle;
                }
                span {
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    color: #3c3c33;
                }
            }
            .phone {
                height: 40px;
                padding: 5px 0 5px 0;
                display: inline-block;
                margin-left: 66px;
                img {
                    width: 40px;
                    height: 40px;
                    vertical-align: middle;
                }
                span {
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: 0.5px;
                    color: #3c3c33;
                }
                &.en_language {
                    margin-left: 50px;
                }
            }
            .language {
                display: inline-block;
                margin-left: 259px;
                position: relative;
                text-align: left;
                cursor: pointer;
                &:hover {
                    span {
                        color: #e21711;
                    }
                     span:first-child{
                         color: #e21711;
                     }
                    
                }
                span:first-child{
                    color: #b3b3b3;
                    font-size: 20px;
                    font-weight: bold;
                }
                span:nth-child(2) {
                    font-size: 13px;
                    margin-left: -5px;
                }
            }
            .language.en_language {
                margin-left: 20px;
            }
            .language::after {
                content:'▼';
                display: block;
                position:absolute;
                right: -15px;
                top: 6px;
                color: #b3b3b3;
                font-size: 14px;
            }
            ul {
                position: absolute;
                right: -10px;
                top: 25px;
                width: 0px;
                background-color: #ffffff;
                z-index: 1000;
                box-shadow: 0 1px 5px rgba(0, 0, 0, .2);
                border: 1px solid #ccc; 
                transform: translateY(-1000px);
                animation: width 0.6s ease-out,transform 0.6s ease-out;
                border-radius: 2px;
                padding: 8px 5px;
                li {
                    height: 10px;
                    font-size: 13px;
                    height: 15px;
                    text-align: center;
                    padding: 3px 0;
                    width: 100%;
                    cursor: pointer;
                    &:hover {
                        color: #e21711;
                    }
                }
                li:active {
                    background-color: #cccccc;
                }
            }
            ul.active {
                width: 70px;
                transform: translateY(0px)
            }
        }
        .header_menu {
            width: 100%;
            height: 85px;
            background-color: rgba(0, 0, 0, 0.6);
            position: absolute;
            top: 50px;
            left: 0;
            z-index: 999;
            .menu {
                height: 85px;
                overflow: hidden;
                .logo {
                    height: 85px;
                    width: 212px;
                    margin-left: 210px;
                    float: left;
                    cursor: pointer;
                    img {
                        width: 211px;
                        height: 85px;
                    }
                }
                .menu_list {
                    margin-left: 64px;
                    float: left;
                    height: 85px;
                    ul {
                        height: 85px;
                        li {
                            height: 85px;
                            width: 120px;
                            text-align: center;
                            float: left;
                            position: relative;
                            overflow: hidden;
                            transform: skewX(-25deg);
                            cursor: pointer;
                            .before {
                                position: absolute;
                                width: 42px;
                                height: 85px;
                                top: 0;
                                left: -21px;
                                transform: skewX(25deg);
                                background:url(../../static/img/line.png) no-repeat center center;
                                z-index: 79;
                            }
                            .after {
                                position: absolute;
                                width: 42px;
                                height: 85px;
                                top: 0;
                                right: -21px;
                                transform: skewX(25deg);
                                // background-image:linear-gradient(30deg, #ccc 10%, #fff 80%,#ccc 10%);
                                background:url(../../static/img/line.png) no-repeat center center;
                                z-index: 79;
                            }
                            .text {
                                height: 85px;
                                width: 120px;
                                position: absolute;
                                top: 0;
                                left: 0;
                                z-index: 99;
                                &:hover {
                                    p{
                                        color:#e21711;
                                    }
                                    
                                }
                                p {
                                    margin: 0 ;
                                    color: #fff;
                                    span {
                                        display: block;
                                        transform: skewX(25deg);
                                    }
                                }
                                p:first-child{
                                    margin-top: 20px;
                                    font-size: 20px;
                                }
                                p:last-child {
                                    margin-top: 5px;
                                    font-size: 14px;
                                }
                            }                            
                        }
                        .show_active {
                            background-color: #e21711;
                            position: relative;
                            .text:hover{
                                    p{
                                        color:#fff;
                                    }
                            }
                        }
                        .show_active::after {
                            position: absolute;
                            width:100%;
                            height: 2px;
                            bottom: 0;
                            left: 0;
                            background-color: #fff;
                        }
                        .clear {
                            clear:both;
                            float:none;
                        }
                    }
                }
                .search {
                    float: left;
                    margin-left: -56px;
                    position: relative;
                    input {
                        border: 0;
                        outline: none;
                        height: 41px;
                        width: 187px;
                        margin-top: 21px;
                        background-color: rgba(52, 39, 57, 0.52);
                        padding: 0 35px 0 5px;
                        color: #fff;
                    }
                    .search_ico {
                        position: absolute;
                        right: 14px;
                        top: 33px;
                        width: 18px;
                        height: 20px;
                        background: url(../../static/img/search_ico.png)no-repeat center center;
                    }
                }
                .foreign{
                    float: left;
                     margin-top: 26px;
                    a{
                        display: inline-block;
                        margin-left: 20px;
                        img{
                             width: 31px;
                            height: 31px;
                        }
                    }
                }
            }
            
        }
        .footer {
            width: 100%;
           .footer_top {
               height: 300px;
               background: #292d30;
               .nav {
                   width: 1170px;
                   margin: 0 auto;
                   padding-top: 40px;
                   ul {
                    
                       li {
                           width: 390px;
                           float: left;
                           position: relative;
                           text-align: left;
                           span {
                               color: #fff;
                               font-size: 20px;
                           }
                       }
                       .clear {
                           clear: both;
                           float:none;
                       }
                       li::before {
                           content:"";
                           display: block;
                           position:absolute;
                           width: 5px;
                           height: 20px;
                           background-color: #e21711;
                           top: 2px;
                           left: -10px;
                       }
                       li:nth-child(1) {
                        //    margin-right: 298px;
                       }
                       li:nth-child(2) {
                        //    margin-right: 375px;
                       }
                   }
               }
               .link {
                   width: 1170px;
                   margin: 0 auto;
                   margin-top: 36px;
                   overflow: hidden;
                   .link_url {
                       float: left;
                       .link_tap {
                           width: 390px;
                           float: left;
                            ul {
                                overflow: hidden;
                                // width: 300px;
                                // height: 200px;
                                li {
                                    margin-bottom: 35px;
                                    text-align: left;
                                    float: left;
                                    margin-right: 19px;
                                    min-width: 115px;
                                    max-width: 140;
                                    a {
                                        color: #fff;
                                        text-decoration:none;
                                        font-size: 14px;
                                        &:hover {
                                            color: #e21711;
                                        }
                                    }
                                    &:nth-child(7) {
                                        margin-bottom: 0
                                    }
                                    &:nth-child(8) {
                                        margin-bottom: 0
                                    }
                
                                }
                            }
                       }
                       .link_conact{
                           width: 390px;
                           float: left;
                           ul {
                               li {
                                  margin-bottom: 25px; 
                                  text-align: left;
                                  img {
                                      vertical-align: middle;
                                      width: 20px;
                                  }
                                  span {
                                      font-size: 14px;
                                      color: #fff;
                                  }
                               }
                               li:last-child {
                                   margin-bottom: 0;
                               }
                           }
                       }
                   }
                   .link_ewm {
                       float: left;
                       p {
                           color: #fff;
                            font-size: 14px;
                            text-align: left;
                       }
                       .server {
                           min-width: 170px;
                           float: left;
                           text-align: left;
                           p {
                               color: #fff;
                               font-size: 14px;
                               text-align: left
                           }
                           img {
                               width: 125px;
                               height: 125px;
                               margin: 14px  0 9px 0;
                           }
                       }
                       .information {
                           float: left;
                           text-align: left;
                            p {
                               color: #fff;
                               font-size: 14px;
                               text-align: left
                           }
                          img {
                               width: 125px;
                               height: 125px;
                               margin: 14px  0 9px 0;
                           } 
                       }
                   }
               }
           }
           .footer_bottom {
               height: 70px;
               background: #1e2225;
               color: #fff;
               line-height: 70px;
               span{
                   display: inline-block;
                   width: 20px;
               }
           }
        }
        .back_top {
            display: none;
            cursor: pointer;
            bottom: 20px;
            right: 15px;
            position: fixed;
            width: 44px;
            height: 44px;
            line-height: 44px;
            box-shadow: 0 6px 12px 0 rgba(0,0,0,.15);
            z-index: 999;
            background: #fff;
            font-size: 32px;
            // font-weight: 10px;
            text-align: center;
            color: #e21711;
            &.show {
                display: block;
            }
        }
        .contact_fixed {
            display: inline-block;
            position: fixed;
            right: 15px;
            bottom: 198px!important;
            z-index: 999;
            width: 44px;
            height: 90px;
            line-height: 90px;
            box-shadow: 0 6px 12px 0 rgba(0,0,0,.15);
            background-color: #fff;
            text-align: center;
            cursor: pointer;
            .icon {
                font-size: 30px;
                color: #e21711;
            }
            span {
                display: inline-block;
                width: 14px;
                font-size: 14px;
                word-wrap:break-word;
                color: #e21711;
                line-height: 17px;
                letter-spacing: 2px;
                text-decoration: none;
            }
            .contact_slide {
                box-sizing: border-box;
                position: absolute;
                bottom: 0;
                width: 320px;
                min-height: 50px;
                padding: 16px 20px 16px 20px;
                background: #fff;
                box-shadow: 0 6px 12px 0 rgba(0,0,0,.15);
                z-index: 4;
                right: 52px;
                opacity: 0;
                visibility: hidden;;
                transition: all .3s;
                transition-delay: .1s;
                ul {
                    li {
                        height: 48px;
                        line-height: 48px;
                        img {
                            width: 24px;
                            height: 25px;
                            vertical-align: middle;
                        }
                        span {
                            display: inline-block;
                            color: #5f6367;
                            font-size: 14px;
                            width: 80%;
                        }
                    }
                }
            }
            &:hover {
                .contact_slide{
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }
     @media screen and (min-width:2560px) {
         .container {
            .header_info {
                .info {
                    margin-left: 700px;
                }
            }
            .header_menu {
                .menu {
                    .logo {
                        margin-left: 200px;
                    }
                }
            }
         }
     }
    @media screen and (min-width:1600px) and (max-width:1880px) {
         .container {
            .header_info {
                .info {
                    margin-left: 700px;
                }
            }
            .header_menu {
                .menu {
                    .logo {
                        margin-left: 200px;
                    }
                }
            }
         }
    }
    @media screen and (min-width:1480px) and (max-width:1600px){
        .container {
            .header_info {
                .info {
                    margin-left: 650px;
                    .language {
                        margin-left: 150px
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 240px;
                    }
                }
            }
        }
        
    }
    @media screen and (min-width:1380px) and (max-width:1480px){
        .container {
            .header_info {
                .info {
                    margin-left: 560px;
                    .language {
                        margin-left: 150px
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 200px;
                    }
                }
            }
        }
        
    }
    @media screen and (min-width:1280px) and (max-width:1380px){
        .container {
            .header_info {
                .info {
                    margin-left: 460px;
                    .language {
                        margin-left: 150px
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 150px;
                    }
                }
            }
        }
        
    }
    @media screen and (min-width:1180px) and (max-width:1280px){
        .container {
            .header_info {
                .info {
                    margin-left: 300px;
                    .language {
                        margin-left: 150px
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 100px;
                    }
                }
            }
        }
        
    }
    @media screen and (min-width:1100px) and (max-width:1180px){
         .container {
            .header_info {
                .info {
                    margin-left: 300px;
                    .language {
                        margin-left: 130px
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        margin-left: 60px;
                    }
                }
            }
        }

    }
    @media screen and (min-width:960px) and (max-width:1100px){
        .container {
            .header_info {
                .info {
                    margin-left:250px;
                    .language {
                        margin-left: 100px;
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                        display: none;
                        // margin-left: 10px;
                    }
                     .menu_list {
                        // margin-left: 80!important;
                    }
                }
            }
        }
        
    }
    @media screen and (max-width:959px){
        .container {
            .header_info {
                .info {
                    margin-left: 250px;
                    .language {
                        margin-left: 80px;
                    }
                }
            }
            .header_menu {
                .menu  {
                    .logo {
                       display: none;
                    }
                    .menu_list {
                        // margin-left: 0;
                    }
                }
            }
            .footer {
                .footer_top {
                    .link {
                        .link_ewm {
                            .server {
                                img {
                                    margin: 10px 0 5px 0;
                                }
                            }
                            .information {
                                img {
                                    margin: 10px 0 5px 0;
                                }
                            }
                            
                        }
                    }
                }
                
            }
        }
        
    }
   
</style>
<style lang="less">
.banner {
    .el-carousel__arrow {
        width: 38px;
        height: 78px;
        border-radius: 0;
    }
    .el-carousel__arrow--left {
        left: 120px;
        .el-icon-arrow-left {
            width: 12px;
            height: 20px;
            background: url(../../static/img/right_ico.png)no-repeat center center;
            transform: rotateY(180deg)
        }
        .el-icon-arrow-left:before {
            content: ''
        }
    }
    .el-carousel__arrow--right {
        right:120px;
        .el-icon-arrow-right {
            width: 12px;
            height: 20px;
            background: url(../../static/img/right_ico.png)no-repeat center center;
        }
        .el-icon-arrow-right:before {
            content: ''
        }
    }
    .is-active .el-carousel__button {
        width: 110px;
        height: 8px;
        background-color: #e21711;
    }
    .el-carousel__button {
        width: 110px;
        height: 8px;
        background-color: rgba(105, 105, 105, 0.7);
    }
}
</style>


// WEBPACK FOOTER //
// src/components/main.vue